import header from '../../header/parts/headerElements';
import scroll from '../../../helpers/scroll';
import dom from '../../../helpers/dom';
import styles from '../../../helpers/styles';

const tocContainerClass = 'qusd-toc';
const contentClass = 'qusd-single__content';
const headingSelector = 'h2';
const activeClass = 'qusd-toc__link--is-active';

let tocItems = [];

const buildToc = () => {
  const content = dom.getFirstByClassName(contentClass);
  const tocContainer = dom.getFirstByClassName(tocContainerClass);
  if (!content || !tocContainer) return;

  const headings = Array.from(content.querySelectorAll(headingSelector)).filter((heading) => {
    const plainText = heading.textContent.replace(/\s+/g, '').trim();
    return plainText.length > 0;
  });

  if (!headings.length) {
    styles.hideElement(tocContainer);
    return;
  }

  let tocList = tocContainer.querySelector('ol');
  if (!tocList) {
    tocList = document.createElement('ol');
    tocContainer.appendChild(tocList);
  }

  tocItems = [];

  headings.forEach((heading, index) => {
    const id = heading.id || `heading-${index}`;
    if (!heading.id) heading.setAttribute('id', id);

    const text = heading.textContent;

    const li = document.createElement('li');
    li.classList.add('qusd-toc__item');
    const link = document.createElement('a');
    link.href = `#${id}`;
    link.dataset.id = id;
    link.textContent = text;
    link.classList.add('qusd-toc__link', 'js-toc-link');

    li.appendChild(link);
    tocList.appendChild(li);

    tocItems.push({
      id,
      heading,
      link,
    });
  });
};

const handleClick = (e) => {
  const link = e.target.closest('a[data-id]');
  if (!link) return;

  e.preventDefault();

  const targetId = link.getAttribute('href').substring(1);
  const target = document.getElementById(targetId);
  if (target) {
    const offset = header.getHeight();
    const top = target.getBoundingClientRect().top + scroll.getCurrentPosition() - offset;

    window.scrollTo({
      top,
      behavior: 'smooth',
    });
  }
};

const updateActiveItem = () => {
  const currentScroll = scroll.getCurrentPosition();
  const offset = header.getHeight();
  let currentId = null;

  tocItems.forEach(({ id, heading }) => {
    const top = heading.getBoundingClientRect().top + scroll.getCurrentPosition();
    if (currentScroll >= top - offset) {
      currentId = id;
    }
  });

  tocItems.forEach(({ id, link }) => {
    link.classList.toggle(activeClass, id === currentId);
  });
};

const init = () => {
  buildToc();
  tocItems.forEach(({ link }) => link.addEventListener('click', handleClick));
  updateActiveItem();
};

const onScroll = () => updateActiveItem();
const onResize = () => updateActiveItem();

export default {
  init,
  onScroll,
  onResize,
};
